export default "__VITE_ASSET__WZWk605J__"